import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Industries from '../components/Industries';
import Projects from '../components/Projects';
import Partners from '../components/Partners';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import useScrollAnimation from '../hooks/useScrollAnimation';
import { organizationSchema, serviceSchema } from '../data/structuredData';

const HomePage = () => {
  const [scrolled, setScrolled] = useState(false);
  useScrollAnimation(); // Enable scroll-triggered animations

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <SEO
        title="Acoustic Panels & Soundproofing"
        description="HillPoint Global manufactures and installs acoustic panels, soundproofing systems, and architectural acoustics across Qatar, UAE, Saudi Arabia, and India. 500+ projects in 25+ countries including FIFA stadiums."
        keywords="acoustic panels Qatar, soundproofing Dubai, acoustic solutions UAE, architectural acoustics India, acoustic treatment Middle East, noise reduction panels, HillPoint Global"
        url="/"
        structuredData={[organizationSchema, serviceSchema]}
      />
      <div className="min-h-screen bg-hillpoint">
        <Header scrolled={scrolled} />
        <main>
          <Hero />
          <Industries />
          <Projects />
          <Partners />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default HomePage;
